<div class="sourtrack-picker">
  <h2 class="sourtrack-picker__title">Elige el presupuesto a aprobar</h2>
  @if (data.candidates.length === 0) {
    <p>No hay presupuestos que se puedan aprobar en esta oportunidad. Crea o activa uno e inténtalo de nuevo.</p>
  } @else {
    <p>La oportunidad no tiene ningún presupuesto en «Pedido de venta». Al elegir uno se adoptará si hace falta, se aprobará como pedido de venta y se enviará a SourTrack.</p>
    @if (!data.linesVerified) {
      <p class="sourtrack-picker__hint">
        No se pudo comprobar qué presupuestos tienen líneas de venta; se listan todos los activos, no cancelados y sin aprobar.
      </p>
    }
    <ul class="sourtrack-picker__list">
      @for (q of data.candidates; track q.id) {
        <li>
          <span>{{ q.budgetCode || '' }} {{ q.name || 'Presupuesto ' + q.id }}</span>
          <button data-test="sourtrack-pick" nz-button nzType="primary" nzShape="round" nzSize="small" (click)="pick(q.id)">
            Aprobar y enviar
          </button>
        </li>
      }
    </ul>
  }
  <div class="sourtrack-picker__footer">
    <button data-test="sourtrack-picker-cancel" nz-button nzType="text" nzShape="round" (click)="cancel()">
      {{ data.candidates.length === 0 ? 'Cerrar' : 'Cancelar' }}
    </button>
  </div>
</div>
